import React, { Component } from 'react';

class AdvisoryContent extends Component {
    constructor(props) {
        super(props);

        const app = document.getElementById('app');
        const { language } = app.dataset;
        this.state = {
            data: [],
            language,
        };
        this.removeAdvisory = this.removeAdvisory.bind(this);
    }

    removeAdvisory(AdvisoryId) {
        this.state.data.map((items, index) => {
            if (items.AdvisoryId == AdvisoryId) {
                var index = this.state.data.findIndex((item) => item.AdvisoryId == AdvisoryId);
                this.state.data.splice(index, 1);
                this.setState({ data: this.state.data });
            }
        });
    }

    componentDidMount() {
        const orgElement = document.getElementById('organizationId');
        let organizationId = '';

        if (orgElement != 'undefined' && orgElement != null) {
            organizationId = document.getElementById('organizationId').value;
        }

        let baseUrl = '';
        if (document.getElementById('baseUrl') != 'undefined' && document.getElementById('baseUrl') != null) {
            baseUrl = document.getElementById('baseUrl').value;
        }

        const xhr = new XMLHttpRequest();
        xhr.open('GET', `${baseUrl}/api/front/getAdvisoryContent?organizationId=${organizationId}`);
        xhr.setRequestHeader('Content-Type', 'application/json');
        xhr.onload = () => {
            if (xhr.status >= 200 && xhr.status < 300) {
                const data = JSON.parse(xhr.response);
                // console.log('data', data);
                this.setState({ data });
            } else {
                reject(`status: ${xhr.status}, statusText: ${xhr.statusText}`);
            }
        };
        xhr.onerror = () => {
            reject(`status: ${xhr.status}, statusText: ${xhr.statusText}`);
        };
        xhr.send();
    }

    render() {
        // console.log('this.setstate=========>', this.state);
        return (
            <>
                {this.state.data.map((items, index) => (
                    <div className={(Object.keys(this.state.data).length) > 0 ? 'd-flex text-danger font-size-sm py-1 justify-content-center alert-danger w-100 align-items-center flex-wrap alert fade show rounded-0 border-0 mb-0' : 'd-none'} key={index}>
                        <div className="container position-relative">

                            <div className="mx-2 d-flex w-100 my-1 justify-content-center">
                                <svg className="icon mr-2 fill-red" aria-hidden="true" title="">
                                    <use xmlnsXlink="http://www.w3.org/2000/svg" xlinkHref="/img/icons/icon-defs.svg#icon-alert" />
                                </svg>
                                <a href={this.state.language == 'fr' ? `${items.Link}/fr/advisories-alerts` : `${items.Link}/advisories-alerts`} target="_blank" className="text-danger" rel="noreferrer">{this.state.language == 'en' ? items.Message : items.Message_FR}</a>
                                <button type="button" className="close position-absolute position-md-relative" onClick={this.removeAdvisory.bind(null, items.AdvisoryId)} data-dismiss="alert" aria-label="Close">
                                    <svg className="icon-sm fill-red" aria-hidden="true" role="" title="">
                                        <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="/img/icons/icon-defs.svg#icon-close" />
                                    </svg>
                                </button>
                            </div>

                        </div>
                    </div>
                ))}
            </>
        );
    }
}

export default AdvisoryContent;
